import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons';

import Menu from '../components/Menu';


const colors = {
  brand: '#21bfaf',
  text: '#37474f',
  textLight: '#78909c',
  border: '#eceff1',
  bg: '#f8fafa',
};

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  min-height: calc(100vh - 80px);
`;

const Sidebar = styled.aside`
  width: 260px;
  flex-shrink: 0;
  background: white;
  border-right: 1px solid ${colors.border};
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px 20px;
  margin-bottom: 8px;
  border-bottom: 1px solid ${colors.border};
`;

const LogoIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, ${colors.brand} 0%, #1a9e91 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  box-shadow: 0 4px 12px ${colors.brand}40;
`;

const LogoText = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.text};

  span {
    display: block;
    font-size: 11px;
    font-weight: 500;
    color: ${colors.textLight};
    margin-top: 2px;
  }
`;

const Content = styled.main`
  flex: 1;
  padding: 32px;
  background: white;
  min-width: 0;
`;

const SiteAdmin = ({ children }) => {
  return (
    <Container>
      <Sidebar>
        <Logo>
          <LogoIcon>
            <FontAwesomeIcon icon={faShieldCheck} />
          </LogoIcon>
          <LogoText>
            Site Admin
            <span>Management Console</span>
          </LogoText>
        </Logo>
        <Menu />
      </Sidebar>
      <Content>
        {children}
      </Content>
    </Container>
  );
};

SiteAdmin.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SiteAdmin;
